<template>
  <vxe-modal
    ref="modal"
    size="mini"
    v-model="formVisible"
    title="同步协作系统"
    width="300px"
    @show="showModal"
  >
    <el-form
      :model="form"
      ref="FormRef"
      :validate-on-rule-change="false"
      :rules="rules"
      size="mini"
      label-position="left"
      @keyup.enter.native="handleCommit"
    >
      <el-form-item label="预计更新版本号" prop="version">
        <el-input
          v-model="form.version"
          placeholder="请输入需要同步的预计更新版本号"
        ></el-input>
        <template slot="error" slot-scope="slot">
          <errorTooltip :content="slot.error"></errorTooltip>
        </template>
      </el-form-item>
      <el-form-item label="更新批次" prop="batchNum">
        <el-select
          clearable
          v-model="form.batchNum"
          placeholder="请选择更新批次"
        >
          <el-option label="第一批" value="第一批"></el-option>
          <el-option label="第二批" value="第二批"></el-option>
          <el-option label="第三批" value="第三批"></el-option>
        </el-select>
        <template slot="error" slot-scope="slot">
          <errorTooltip :content="slot.error"></errorTooltip>
        </template>
      </el-form-item>
    </el-form>
    <el-button
      @click="handleCommit"
      style="float: right; margin-top: 10px"
      size="mini"
      type="primary"
      >确认</el-button
    >
    <!-- 同步问题明细 -->
    <SyncToCooperationDetail
      ref="SyncToCooperationDetail"
      :tableList="detailTableList"
      @successBack="detailSuccessBack"
    />
  </vxe-modal>
</template>
<script>
import SyncToCooperationDetail from './SyncToCooperationDetail.vue'
export default {
  name: 'AcceptModal',
  components: {
    SyncToCooperationDetail
  },
  data() {
    return {
      formVisible: false,
      form: {
        version: '',
      },
      rules: {
        version: [
          { required: true, message: '请输入需要同步的版本号', trigger: 'change' }
        ],
        batchNum: [
          { required: true, message: '请选择更新批次', trigger: 'change' }
        ]
      },
      detailTableList: [] // 明细数据列表
    }
  },
  methods: {
    // 明细成功同步
    detailSuccessBack() {
      this.$refs.SyncToCooperationDetail.formVisible = false
      this.formVisible = false
    },
    // 调用同步接口，获取需要同步的问题数据
    async handleSync() {
      const { data: res } = await this.$http.get('/Bugs/YKBug/issued', {
        params: {
          productionType: this.$store.state.productType,
          planIssuedVersion: this.form.version,
          batchNum: this.form.batchNum
        }
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      } else if (res.data.length === 0) {
        this.$message.error('该产品类型下不存在输入版本的问题!')
        return
      }
      this.detailTableList = res.data
      this.$refs.SyncToCooperationDetail.formVisible = true
      // this.formVisible = false
    },
    // 校验处理说明
    validNote(rule, value, callback) {
      if (this.form.handleResult === '不处理' && !value) {
        callback(new Error('当处理结果为不处理时处理说明为必填!'))
      } else {
        callback()
      }
    },
    showModal() {
      this.form = {
        version: '',
      }
      this.$nextTick(() => {
        this.$refs.FormRef.clearValidate()
      })
    },
    async handleCommit() {
      const valid = await this.validEnter()
      if (!valid) {
        return
      }
      // this.$emit("sureHandler", this.form);
      this.handleSync()
    },
    async validEnter() {
      let flag = false
      await this.$refs.FormRef.validate().then(
        res => {
          flag = res
        },
        err => {
          flag = err
        }
      )
      return flag
    },
  },
}
</script>
<style lang='less' scoped>
// vxemodal部分，美化标题太大的问题
/deep/ .vxe-modal--header {
  // font-size: 12px !important;
  height: 26px !important;
  padding: 2px 10px 0 10px !important;
}

// vxemodal关闭按钮
/deep/ .vxe-modal--close-btn {
  position: absolute !important;
  right: 8px !important;
  top: 6px !important;
  z-index: 1 !important;
  cursor: pointer !important;
}

// vxemodal标题
/deep/ .vxe-modal--title {
  font-size: 12px !important;
}
</style>